import { Routes, Route } from "react-router-dom";
import DbmsLayout from "components/dbms/DbmsLayout";
import FireReceiverManagementComponent from "components/dbms/FireReceiverManagementComponent";
import FireReceiverSettingsComponent from "components/dbms/FireReceiverSettingsComponent";
import StatusLogComponent from "components/dbms/StatusLogComponent";
import DataTransmissionLogComponent from "components/dbms/DataTransmissionLogComponent";
import BusinessManagementComponent from "components/dbms/BusinessManagementComponent";
import BusinessAccountManagementComponent from "components/dbms/BusinessAccountManagementComponent";
import UserAccountManagementComponent from "components/dbms/UserAccountManagementComponent";
import FireProtectionTargetManagementComponent from "components/dbms/FireProtectionTargetManagementComponent";
import NoticeManagementComponent from "components/dbms/NoticeManagementComponent";
import ExternalApiIntegrationComponent from "components/dbms/ExternalApiIntegrationComponent";
import ExternalApiTransmissionLogComponent from "components/dbms/ExternalApiTransmissionLogComponent";
import SystemMonitoringComponent from "components/dbms/SystemMonitoringComponent";
import FireEquipmentMdbComponent from "components/dbms/FireEquipmentMdbComponent";
import FireReceiverMdbComponent from "components/dbms/FireReceiverMdbComponent";

export default function DbmsPage() {
  return (
    <DbmsLayout>
      <Routes>
        <Route
          path="/fire-receiver/management/*"
          element={<FireReceiverManagementComponent />}
        />
        <Route
          path="/fire-receiver/settings/*"
          element={<FireReceiverSettingsComponent />}
        />
        <Route path="/logs/status/*" element={<StatusLogComponent />} />
        <Route
          path="/logs/data-transmission/*"
          element={<DataTransmissionLogComponent />}
        />
        <Route
          path="/business/management/*"
          element={<BusinessManagementComponent />}
        />
        <Route
          path="/business/accounts/*"
          element={<BusinessAccountManagementComponent />}
        />
        <Route
          path="/users/accounts/*"
          element={<UserAccountManagementComponent />}
        />
        <Route
          path="/fire-protection/targets/*"
          element={<FireProtectionTargetManagementComponent />}
        />
        <Route
          path="/notices/management/*"
          element={<NoticeManagementComponent />}
        />
        <Route
          path="/external-api/integration/*"
          element={<ExternalApiIntegrationComponent />}
        />
        <Route
          path="/external-api/transmission-logs/*"
          element={<ExternalApiTransmissionLogComponent />}
        />
        <Route
          path="/system/monitoring/*"
          element={<SystemMonitoringComponent />}
        />
        <Route
          path="/fire-equipment/mdb/*"
          element={<FireEquipmentMdbComponent />}
        />
        <Route
          path="/fire-receiver/mdb/*"
          element={<FireReceiverMdbComponent />}
        />
      </Routes>
    </DbmsLayout>
  );
}
